import parse from 'html-react-parser'

export default function Breadcrumbs({ breadcrumbs }: { breadcrumbs: any }) {
  if (!breadcrumbs) return null

  // Rankmath includes nav even if there's no links, so don't include if there's no links
  if (breadcrumbs.includes('<nav') && !breadcrumbs.includes('href')) return null

  return (
    <div className={`site-breadcrumbs group z-10 mb-0 flex items-center`}>
      <span className="p--small font-normal text-fg group-hover:text-primary prose-p:text-inherit prose-p:font-inherit prose-a:text-inherit prose-a:no-underline prose-a:font-inherit">
        {parse(breadcrumbs)}
      </span>
    </div>
  )
}
